/**
 * @module Section | Thumb Carousel - Editable
 * @description
 */
import ThumbCarousel from '~/blocks/Carousel/ThumbCarousel';
import { JsonObject, useMonarchSlotContext } from '@redventures/cohesion-utils-react';
import { ImageProps } from '~/types/common';
import SectionThumbCarouselDefaults from './defaults';

interface Slide {
  heading: string;
  copy: string | JSX.Element;
  image: ImageProps;
}

interface Data extends JsonObject {
  slides: Slide[];
};

const SectionThumbCarouselEditable = ( ) => {
  const { data } = useMonarchSlotContext<Data>();

  const {
    slides
  } = data ?? SectionThumbCarouselDefaults;

  return (
    <ThumbCarousel
      position="MONARCH"
      slides={ slides }
    />
  );
};

SectionThumbCarouselEditable.displayName = 'Section | Thumb Carousel - Editable';

export default SectionThumbCarouselEditable;
